import clsx from "clsx";

import { Box, IconButton, Typography } from "@mui/material";
import { Tooltip } from "@shared/Tooltip";

import { useStyles } from "./Tag.style";

const getTitleWithTooltip = (title: string | undefined) => {
    if (title && title.length > 21) {
        return title;
    }
    return "";
};
export interface Props {
    item: API.Tag;
    onClick?: (tag: API.Tag) => void;
    theme?: "dark" | "light";
}
export const Tag = (props: Props) => {
    const { classes } = useStyles(props);

    const onClick = () => {
        if (props.onClick) {
            props.onClick(props.item);
        }
    };

    const isWrongTab = !props.item?.key || (props.item?.type === "scoped" && !props.item.value);

    if (isWrongTab) {
        return null;
    }

    return (
        <Tooltip placement="top" title={getTitleWithTooltip(props.item.value)}>
            <Box className={classes.container} onClick={onClick}>
                <Box className={classes.keyBox}>
                    <Typography variant="caption" className={classes.label}>
                        {props.item.key}
                    </Typography>
                </Box>
                {props.item.value ? (
                    <Box className={classes.valueBox}>
                        <Typography variant="caption" className={classes.label}>
                            {props.item.value}
                        </Typography>
                    </Box>
                ) : null}
                {props.onClick ? (
                    <IconButton className={classes.button} onClick={onClick} size="large">
                        <i className={clsx("fa-solid fa-xmark", classes.icon)} />
                    </IconButton>
                ) : null}
            </Box>
        </Tooltip>
    );
};
